export default {"src":"/_next/static/media/order-managementFill.39e62e5e.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};